import React, {useState, useCallback} from 'react';
import classNames from 'classnames';
import Lightbox from 'react-image-lightbox';

const StaticImageGalleryType = ({nextContent, images, ratio}) => {
    const classes = [];
    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    if (!ratio) {
        ratio = '0';
    }

    if (images.length === 2 || images.length === 4) {
        classes.push('col-md-6');
    } else if (images.length >= 3) {
        classes.push('col-md-6', 'col-lg-4');
    }

    const getNextReference = (index) => {
        if (nextContent && (nextContent.type === 'singleChoice' || nextContent.type === 'multipleChoice')) {
            return `${nextContent.id}_${nextContent.choices[index].id}`;
        }
        return index;
    };

    const handleClick = useCallback((e) => {
        // if following Content exists and is of singleChoice type
        if (nextContent && nextContent.type === 'singleChoice') {
            const index = e.target.dataset['index'];
            const targetElement = document.querySelector(`#singlechoice-${getNextReference(index)}`);
            targetElement.click();
        }
        // if following Content exists and is of multipleChoice type
        if (nextContent && nextContent.type === 'multipleChoice') {
            const index = e.target.dataset['index'];
            const targetElement = document.querySelector(`#multiplechoice-${getNextReference(index)}`);
            targetElement.click();
        }
    }, []);

    const handleOpenLightbox = useCallback((e) => {
        const index = e.target.dataset['index'];
        setPhotoIndex(index);
        setIsOpen(true);
    }, []);

    const handleCloseLightbox = useCallback((e) => {
        setIsOpen(false);
    }, []);

    return (<div className="row content-static-image-gallery">
        {images.map((({caption, url}, index) => (
            <div className={classNames('col-sm-12', classes, 'content-static-image-gallery-container')} key={index} >
                <div className={'content-static-image-gallery-zoom'} data-index={index} onClick={handleOpenLightbox} />
                {ratio !== '0' ? (
                    <div className={classNames('aspect-ratio-box', `ratio_${ratio}`)}>
                        <img src={url} alt={caption} title={caption} data-index={index} onClick={handleClick} id={`singlechoice-img-${getNextReference(index)}`}
                            className="img-fluid img-thumbnail singlechoice-img" />
                    </div> ) : (
                    <img src={url} alt={caption} title={caption} data-index={index} onClick={handleClick} id={`singlechoice-img-${getNextReference(index)}`}
                        className="img-fluid img-thumbnail singlechoice-img" />
                )}
                {caption}
            </div>
        )))}
        {isOpen && (
            <Lightbox
                mainSrc={images[photoIndex].url}
                onCloseRequest={handleCloseLightbox}
                imageCaption={images[photoIndex].caption}
            />
        )}
    </div>);
};

export default StaticImageGalleryType;
